"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var haversine_distance_calculator_helper_1 = require("@/utils/haversine-distance-calculator-helper");
var parameters_1 = __importDefault(require("@/config/parameters"));
var PointOfInterestNearbyRecommended = /** @class */ (function (_super) {
    __extends(PointOfInterestNearbyRecommended, _super);
    function PointOfInterestNearbyRecommended() {
        var _this = _super.call(this) || this;
        _this.loader = false;
        _this.imagesCDNHost = parameters_1.default.cdn.host;
        _this.nearbyGeoJson = {
            type: "FeatureCollection",
            features: []
        };
        return _this;
    }
    PointOfInterestNearbyRecommended.prototype.onChangePointOfInterest = function () {
        this.fetch();
    };
    PointOfInterestNearbyRecommended.prototype.mounted = function () {
        this.fetch();
    };
    PointOfInterestNearbyRecommended.prototype.fetch = function () {
        var _this = this;
        this.loader = true;
        this.$getNearbyService.request(this.pointOfInterest.id, this.$i18n.locale).then(function (response) {
            _this.nearbyGeoJson = response;
            _this.loader = false;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    PointOfInterestNearbyRecommended.prototype.getDistance = function (pointOfInterestGeoJson) {
        return haversine_distance_calculator_helper_1.HaversineDistanceCalculatorHelper.calculate({ latitude: this.pointOfInterest.gps_latitude, longitude: this.pointOfInterest.gps_longitude }, { latitude: pointOfInterestGeoJson.geometry.coordinates[1], longitude: pointOfInterestGeoJson.geometry.coordinates[0] });
    };
    PointOfInterestNearbyRecommended.prototype.preview = function (pointOfInterestId) {
        this.$router.push({ name: 'pointOfInterestDataById', params: { pointOfInterestId: pointOfInterestId } });
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], PointOfInterestNearbyRecommended.prototype, "pointOfInterest", void 0);
    __decorate([
        vue_property_decorator_1.Watch('pointOfInterest')
    ], PointOfInterestNearbyRecommended.prototype, "onChangePointOfInterest", null);
    PointOfInterestNearbyRecommended = __decorate([
        vue_property_decorator_1.Component({
            name: 'PointOfInterestNearbyRecommended'
        })
    ], PointOfInterestNearbyRecommended);
    return PointOfInterestNearbyRecommended;
}(vue_1.default));
exports.default = PointOfInterestNearbyRecommended;
